import type { ReactNode } from 'react';
import { Card } from './Card';
import { cx } from './cx';

export interface EmptyStateProps {
  title: string;
  body: string;
  action?: ReactNode;
  /** Optional illustration URL, shown above the title. */
  image?: string;
  className?: string;
}

export const EmptyState = ({ title, body, action, image, className = '' }: EmptyStateProps) => (
  <Card padding="lg" className={cx('text-center', className)}>
    {image && (
      <img src={image} alt="" aria-hidden="true" loading="lazy" className="mx-auto mb-5 h-44 w-auto max-w-full object-contain" />
    )}
    <h2 className="mb-2 text-h3">{title}</h2>
    <p className="mx-auto mb-5 max-w-prose text-body text-ink-muted">{body}</p>
    {action}
  </Card>
);
